module.exports = __webpack_public_path__ + "media/images/front/treatment_support/img_tutorial_03-1104164b77833b40b28411b57e2c3180.png";